var altArray = [];
var customizeTotal = 0;
var currentStep = 1;
var skipSteps = [];
var prescriptionFlag = false;
var planoFlag = false;
var productProperty = [];
var productBundle = [];
var activeSteps = [];
Shopify.queue = [];
var lensStep = '';

var advOptsArr = [];
var advImgsArr = [];
var nonPrescOpt = '';

var appliedCode = theme.custom.appliedDiscountCode;
var appliedDiscount = 0;
var discountFlag = false;
var discount100Decimal = 1;


var selectedVariantJSON = JSON.parse($('[data-selected-variant=""]').html());

if (theme.custom.advOpts != undefined) {
    advOptsArr = theme.custom.advOpts.split('| ');
}
if (theme.custom.advImgs != undefined) {
    advImgsArr = theme.custom.advImgs.split('| ');
}
var currentGalleryIndex = 0;
var hasColorImage = false;
$(document).ready(function() {
    if ($('.mainGallery').length > 0) {
        // push unique color to array
        $('.mainGallery li[data-alt]').each(function() {
            var altVal = $(this).data('alt');
            if ($.inArray(altVal, altArray) == -1) {
                altArray.push(altVal);
            }
        });
        var prevSlick = '<button aria-label="Previous Image" type="button" class="slick-prev"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-arrow-left" viewBox="0 0 32 32"><path fill="#000000" d="M24.333 28.205l-1.797 1.684L7.666 16l14.87-13.889 1.797 1.675L11.269 16z"/></svg></button>';
        var nextSlick = '<button aria-label="Next Image" type="button" class="slick-next"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-arrow-right" viewBox="0 0 32 32"><path fill="#000000" d="M7.667 3.795l1.797-1.684L24.334 16 9.464 29.889l-1.797-1.675L20.731 16z"/></svg></button>'
        $('.mainGallery').slick({
            infinite: true,
            //lazyLoad: 'ondemand',
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            fade: false,
            dots: true,
            asNavFor: '.tmbNav',
            prevArrow: prevSlick,
            nextArrow: nextSlick

        });

        $(".tmbNav").slick({
            infinite: true, 
            slidesToShow: 5,
            slidesToScroll: 1,
            arrows: true,
            asNavFor: '.mainGallery',
            lazyLoad: 'ondemand',
            focusOnSelect: true,
            prevArrow: prevSlick,
            nextArrow: nextSlick,
            responsive: [
                {
                    breakpoint: 1281,
                    settings: {
                        slidesToShow: 4
                    }
                }, 
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 3
                    }
                }
            ]
        });
        $('.mainGallery').on('beforeChange', function(event, slick, currentSlide, nextSlide) {
          $(slick.$slides).find('video').each(function() {
            this.pause();
            this.currentTime = 0;
            $(this).closest('.videoWrapper').removeClass('playing');
            //$(this).removeClass('playing');
            //$(this).closest('.video-wrapper').find('.video-play-btn').fadeIn(0);
          });
        });
        $('.mainGallery').on('afterChange', function(event, slick, currentSlide) {
            //console.log(slick)
            //console.log('mainGallery', slick, slick.currentSlide, currentSlide);
            var $current = $(this).find('.slick-slide[data-slick-index="' + currentSlide + '"]');
            var video = $current.find('video').get(0);

            if (video) {
                video.play().catch(() => {});
                $current.find('.videoWrapper').addClass('playing');
            }
            //currentGalleryIndex = slick.currentSlide;
        });
        
        $('.tmbNav').on('init', function (event, slick) {
            checkTmb()
        });
        $('.tmbNav').on('setPosition', function () {
          checkTmb();
        });


        $('body').on('click', '.gallerySlide a', function() {
      		return false;
    	});


        var variant_id = $(".product-variant-id").val();
	    if (variant_id == '') {
	    	var firstVariantKey = Object.keys(__variants)[0];  
			var variant_id = __variants[firstVariantKey];  
	    }

        
        $('.product-form__input--swatch .swatch-input__input').each(function() {
	        $(this).attr('value');
	        if (__variants[variant_id].featured_image.alt != null) {
	            if ($(this).attr('value') == $.trim(__variants[variant_id].featured_image.alt).split(' | ')[0]) {
	                hasColorImage = true;
	            }
	        }
	    });

    }
    var selectedColor = $('.product-form__input--swatch input:checked').val()
    var scrollPos = $(window).scrollTop(); 
    filterGallery(selectedColor, scrollPos, 0);
    showHideUnavailable();

}); // end ready



function checkTmb() {
    var ww = $(window).width();
    var vs = 5;
    var tmbCount = $('.tmbSlide').not('.slick-cloned').length;
    var tmbOverflow  = false;

    if (ww < 1281) {
      vs = 4;
    } 
    if (ww < 991) {
      vs = 3;
    }

    if (tmbCount > vs) {
      tmbOverflow = true
    }
    $(".tmbNav").attr('data-overflow', tmbOverflow);
}
$('body').on('click', '.customizeBtn', function() {
    $.ajaxSetup({
        async: false
    }); 
    if ($('.customizeSection  *').length == 0) {
        loadCustomizer()
    }
    $.ajaxSetup({
        async: true 
    }); 

    $('body').addClass('optionOpen');
    setTimeout(function(){ 
         $('body').addClass('optionOpened');
    }, 1);
    // selected variant
    selectedVariantJSON = JSON.parse($('[data-selected-variant=""]').html());
    var variantSelected = selectedVariantJSON.option1;
    if (selectedVariantJSON.option2 != null) {
        variantSelected = variantSelected+' - '+selectedVariantJSON.option2;
    }
    if (selectedVariantJSON.option3 != null) {
        variantSelected = variantSelected+' - '+selectedVariantJSON.option3;
    }
    $('.optionModalBox .prodInfo .variantSelected').text(variantSelected);
    updateOptionProgress(currentStep)
});
$('body').on('click', '.option-close', function() {
    $('body').removeClass('optionOpened');
    setTimeout(function(){ 
         $('body').removeClass('optionOpen');
    }, 600);
   
});

// prev next
var changeTimer;
$('body').on('click', '.nextOption', function() {
    //prevStep = currentStep;
    //changeStep(1);
    $('.optionStep[data-step="'+currentStep+'"] input:checked').trigger('click')
});
$('body').on('click', '.backOption', function() {
    var stepsSize = activeSteps.length;
    currentStep = activeSteps[stepsSize-1]; 
    // get last step in array then remove
    //console.log('currentStep:'+currentStep);
    $('.optionModalBox').attr('data-current-step', currentStep);        
    $('.optionStep[data-step="'+currentStep+'"]').find('.noAdv input:checked').attr('data-advance', 0); 
    activeSteps.splice(-1);


    checklensButton(currentStep);
    updateOptionProgress(currentStep); 
   
});

$('.optionStep  .uploadField').val('');

var optsActionHTML  = '<span class="actionBox"><button type="button" class="chooseMe">Choose this lens</button><button type="button" class="cancel">Cancel</button></span>';

$('body').on('click', '.actionBox .cancel', function() {
    $(this).closest('label').find('input[type="radio"]').prop('checked', false).attr('data-advance', 0);  
});

$('body').on('click', '.actionBox .chooseMe', function() {
    $('.optionSelect label').each(function() {
        var optInput = $(this).find('input[type="radio"]');
        var optTitle = optInput.attr('data-value');
        //console.log('advOptsArr');
        //console.log(advOptsArr);
        var inArr = $.inArray(optTitle, advOptsArr); 
        if (inArr > -1) {
            $(this).addClass('noAdv');
            optInput.attr('data-advance', 0);
        }
    });

    $(this).closest('fieldset').find('label input').attr('data-advance', 0);
    $(this).closest('label').find('input[type="radio"]').attr('data-advance', 1).trigger('click');
});


$('body').on('click', '.optionSelect label input[type="radio"]', function() {
    //console.log('opt change');
    var thisOption = $(this);
    var thisOptionStep  = thisOption.closest('.optionStep');
    var thisFieldset = thisOption.closest('.optionSelect');
    var thisPriceTxt = thisOption.closest('label').find('em').text();
    var dataAdvance = parseInt(thisOption.attr('data-advance')); 
    var dataOptName = thisOption.closest('.optionSelect').attr('data-option');
    var dataOptValue = thisOption.val();
    var dataOptType = thisFieldset.attr('data-type');
    var nextOptionAttr = thisOption.attr('data-next-option');
    var labelElem = $(this).closest('label'); 

    var filter = $('select.single-option-selector[data-name="Color"] option:selected').val();
    if (filter === undefined) {
        filter = '';
    }
        filter = filter.replace(/\W+(?!$)/g, '-').toLowerCase();
        filter = filter.replace(/\W$/, '').toLowerCase();

    var scrollPos = $(window).scrollTop();    
    filterGallery(filter, scrollPos, currentGalleryIndex);  

    thisFieldset.attr('data-value', dataOptValue);
    var thisFieldsetVal = thisFieldset.attr('data-value');

    
    
    // show hide upload
    if (thisOption.attr('name') == 'prescription-option') {
        if (thisOption.attr('data-upload') == 'false') {
            $('.optionStep .uploadField').val('');
            $('.optionStep .uploadFieldBox').attr('data-valid', false); 
            thisFieldset.attr('data-upload', false);
        } else {
            thisFieldset.attr('data-upload', true);
        }
    }     

    // trigger next  
    clearTimeout(changeTimer); 
    changeTimer = setTimeout(function(){ 
        
        // if (labelElem.hasClass('noAdv')) {
        //     if (thisOption.prop('checked')) {
        //         return false;
        //     }
        // }
        //prescription_type
        if (thisFieldset.attr('data-option').toLowerCase().indexOf('prescription') > -1) {
            // if non prescription
            planoFlag = false;
            if (thisOption.attr('data-value').toLowerCase().indexOf('non-prescription') > -1 ) {
                prescriptionFlag = false;  
                $('.optionStep .uploadField').val('');
                $('.optionStep .uploadFieldBox').attr('data-valid', false); 
            } else {
                prescriptionFlag = true;  
            }
            if (thisOption.attr('data-value').toLowerCase().indexOf('plano lens') > -1 ) {
                planoFlag = true;
            }    
        }
        //console.log('prescriptionFlag:'+prescriptionFlag); 
        if (prescriptionFlag == false) {
            $('.optionSlider .optionStep.prescriptionStep').prev().find('.optionSelect input:radio').attr('data-advance', 2)
        } else {
            $('.optionSlider .optionStep.prescriptionStep').prev().find('.optionSelect input:radio').attr('data-advance', 1)
        }

        if (dataAdvance > 0) {
            // push active steps to array
            var stepIndex = $.inArray(currentStep, activeSteps);
            if (currentStep > 1) {
                if (stepIndex > 0) {
                    // remove suceeding steps
                    activeSteps.splice(stepIndex, 100);
                }
                // push current step to array
                activeSteps.push(currentStep);
            } else {
                // set array to 1
                activeSteps = [1];
            }
            
            // set step
            if (thisOption.attr('data-next-step') != undefined) {
                // custom step
                var customStepVal = parseInt($('.optionStep[data-option="'+thisOption.attr('data-next-step')+'"]').attr('data-step'));
                currentStep = customStepVal;
                $('.optionModalBox').attr('data-current-step', customStepVal);     

                updateOptionProgress(customStepVal);
            } else {
                // normal advance
                changeStep(dataAdvance);  
            }    
        } 
        // upload field check
        if (thisOption.attr('data-upload') == 'true') {
            // if not empty advance to next step
            if (thisFieldset.find('.uploadField').val() != '') {
                activeSteps.push(currentStep);
                changeStep(1);
            }
        }
        if (dataOptType == 'option') {
            //trigger option change
            $('select.single-option-selector[data-name="'+dataOptName+'"]').val(dataOptValue).trigger('change');
        }
        if (dataOptType == 'bundle') {
            //bundle pass variant price
            thisFieldset.attr('bundle-price', thisOption.attr('data-price'));
            thisFieldset.attr('data-bundle', thisOption.val()); 
        } 
        // pass property to fieldset
        thisFieldset.attr('data-value', thisOption.attr('data-value')); 
        thisFieldset.attr('data-price-text', thisPriceTxt);     
        
        // show hide next step option
        if (typeof nextOptionAttr !== 'undefined' && nextOptionAttr !== false && thisOption.attr('data-next-option') != '') {
            // lens color: grey| amber
            var nextOptArr = nextOptionAttr.split(': ');
            var nextOptKey = nextOptArr[0];
            var nextOptValArr = nextOptArr[1].split('| ');
            $('.optionStep[data-option="' + nextOptKey + '"] .optionSelect  label').hide();

            // console.log('nextOptionAttr');
            // console.log(nextOptionAttr);
            // console.log('nextOptKey');
            // console.log(nextOptKey);

            $.each(nextOptValArr, function(index, item) {
                $('.optionStep[data-option="' + nextOptKey + '"] .optionSelect  input[data-value-lowercase="' + item + '"]').closest('label').show();
                //console.log(item);
            });
        } else {
            if (thisOption.attr('data-advance') == 1) {
                thisOptionStep.next('.optionStep').find('.optionSelect label').show();
            }
            
        }

        //update total
        var mainProductPrice = selectedVariantJSON.price;
        var bundlePrice = 0;
        $.each(activeSteps, function(index, item) {
            var thisBundle = $('.optionStep[data-step="' + item + '"] .optionSelect.bundleSelect');
            var bundleItemPrice = parseInt(thisBundle.attr('bundle-price'));
            if (isNaN(parseInt(bundleItemPrice)) == false) {
                bundlePrice += bundleItemPrice;
            }
        });


        

        var customTotalPrice = mainProductPrice + bundlePrice;
        var customTotalPriceHTML = Shopify.formatMoney(customTotalPrice);

        if (prescriptionFlag && discountFlag) {
            customTotalPriceHTML = '<span class="sale">'+Shopify.formatMoney(customTotalPrice * discount100Decimal)+'</span> <s>'+Shopify.formatMoney(customTotalPrice)+'</s>';
        }  
        if (planoFlag) {
            var customTotalDiscountPrice = mainProductPrice + (bundlePrice * discount100Decimal);
            if (parseInt(customTotalDiscountPrice) < parseInt(customTotalPrice)) {
              customTotalPriceHTML = '<span class="sale">'+Shopify.formatMoney(customTotalDiscountPrice)+'</span> <s>'+Shopify.formatMoney(customTotalPrice)+'</s>';  
            }
            
        }

        //planoFlag = true;


        //console.log('customTotalPrice', mainProductPrice, bundlePrice);
        //alert('.customizeTotal planoFlag '+' || '+planoFlag+' || '+mainProductPrice+' || '+bundlePrice+' || '+customTotalPrice);
        $('.customizeTotal').html(customTotalPriceHTML);
        $('.customizeForm #atcprice').val((customTotalPrice/100).toFixed(2));
        checklensButton(currentStep);
        showHideOpts(); 
    }, 150);

    

    
}); 

// auto advance on file upload change
$('body').on('change', '.optionStep  .uploadField', function() {
    setTimeout(function(){ 
    }, 600);    
        activeSteps.push(currentStep);
        changeStep(1);
        $('.optionStep .uploadFieldBox').attr('data-valid', true); 
    
});
// $('body').on('click', '.uploadFieldBox .uploadBtn', function() {
//   activeSteps.push(currentStep);
//   changeStep(1);
// });
$('.optionSelect input').prop('checked', false);
$('body').on('click', '.customizeAdd', function() {
    $('html, body').addClass('ajaxLoading');
    setTimeout(function() {
        $('#customTimestamp').val(Math.floor(Date.now() / 1000));
        var bundleCount = 0;
        // non async submit to prevent issue 
        $.ajaxSetup({
            async: false
        }); 
        var bundleTitle = $('.optionModalWrapper').attr('data-title');
        var parentID = $('.optionModalWrapper').attr('data-id');
        var ts = $('#customTimestamp').val();
        $.each(activeSteps.reverse(), function(index, item) {
            var thisBundle = $('.optionStep[data-step="'+item+'"] .optionSelect.bundleSelect');   
            var bundleProperty = {};
            var bundleID = thisBundle.attr('data-bundle');
            var bundlePrice = parseInt(thisBundle.attr('bundle-price'));
            var bundleFlag = true;
            if(bundleID === undefined) {
                bundleFlag = false;
            }
            // if (isNaN(bundlePrice)) {
            //     bundlePrice = 0;
            // }
            
            if (bundleFlag == true) {
                bundleCount += 1;
                bundleProperty['_Product Title'] = bundleTitle;
                bundleProperty['_Product ID'] = parentID;
                bundleProperty['_Timestamp'] = ts;
                bundleProperty['_HR'] = '-----';
                
                
                
               
                // console.log('aaaa');
                // console.log(params);
                if (bundleID.indexOf(',') > 0) {
                    //console.log('mmmmmmmmmmmmmmmm');
                    //console.log(params);
                    var bundleArr = bundleID.split(',');
                    $.each( bundleArr, function( key, value ) {
                        var params = {
                            quantity: 1,
                            id: value
                        };
                        params.properties = bundleProperty;
                        $.ajax({
                            type: 'POST',
                            url: '/cart/add.js',
                            async: false,
                            dataType: 'json',
                            data: params,
                            success: function() {
                                // if (typeof callback === 'function') {
                                //     callback();
                                // }
                            },
                            error: function() {}
                        });
                    });
                } else {
                    var params = {
                        quantity: 1,
                        id: bundleID
                    };
                    params.properties = bundleProperty;
                    
                    $.ajax({
                        type: 'POST',
                        url: '/cart/add.js',
                        async: false,
                        dataType: 'json',
                        data: params,
                        success: function() {
                            // if (typeof callback === 'function') {
                            //     callback();
                            // }
                        },
                        error: function() {}
                    });
                    
                }
                
                // console.log('bundleProperty');
                //push_to_queue2(bundleID, 1, bundleProperty, Shopify.moveAlong2);
            }
        });

        if (prescriptionFlag == false && nonPrescOpt != '') {

            var nonPrescOptArr = nonPrescOpt.split('; ');
            $.each( nonPrescOptArr, function( key, value ) {
                var valueArr = value.split(':');
                var xKey = valueArr[0];
                var xValue = valueArr[1];

                var bundlePrice = parseInt($('.bundleStep[data-handle="'+xKey+'"] input[data-value-lowercase="'+xValue+'"]').attr('data-price'));

                var customKey = $('.bundleStep[data-handle="'+xKey+'"] .optionSelect').attr('data-option').split(': ')[0];
                var customPrice = $('.bundleStep[data-handle="'+xKey+'"] input[data-value-lowercase="'+xValue+'"]').closest('label').find('em').text();
                var customValueID = $('.bundleStep[data-handle="'+xKey+'"] input[data-value-lowercase="'+xValue+'"]').closest('label').attr('data-value');

                if (bundlePrice > 0) {
                    // console.log(customKey);
                    // console.log(customValueID);

                    var bundleProperty = {};

                    bundleProperty['_Product Title'] = bundleTitle;
                    bundleProperty['_Product ID'] = parentID;
                    bundleProperty['_Timestamp'] = ts;
                    bundleProperty['_HR'] = '-----';
                    var params = {
                        quantity: 1,
                        id: customValueID
                    };
                    params.properties = bundleProperty;
                    console.log('bbbb');
                    // console.log(params);
                    
                    $.ajax({
                        type: 'POST',
                        url: '/cart/add.js',
                        async: false,
                        dataType: 'json',
                        data: params,
                        success: function() {
                            // if (typeof callback === 'function') {
                            //     callback();
                            // }
                        },
                        error: function() {}
                    }); 
                    
                    
                }
                
            });
        } 
        // submit form
        var customProp = {};
        $('.customizeForm .customProperties .customProp').each(function() {
            customProp[$(this).attr('title')] = $(this).val();
        });
        console.log(customProp);
        pushItem($('.mainForm'), '', 'Added to Cart', customProp);


        $('.customizeForm').submit();
        $.ajaxSetup({
            async: true
        });
    }, 10);
    return false;

});
$('body').on('click', '.customizeEdit', function() {
    currentStep = 1;
    $('.optionModalBox').attr('data-current-step', currentStep);
    updateOptionProgress(currentStep) 
});    
$('body').on('change', '.bundleSelect', function() {
   showHideBundleOpt();    
}); 

var changeTimer2;
$('body').on('change', '.optionStep input[type="checkbox"]', function() {
    var thisOption = $(this);
    var thisOptionStep = thisOption.closest('.optionStep');
    var thisFieldset = thisOption.closest('.optionSelect');
    var dataOptType = thisFieldset.attr('data-type');
    var totalPrice = 0;
    var pricetext = '';
    var selArr = [];
    var selTextArr = [];
    thisFieldset.find('input[type="checkbox"]:checked').each(function() {
        var thisOption = $(this);
        var optionPrice = parseInt(thisOption.attr('data-price'));
        totalPrice += optionPrice;
        selArr.push(thisOption.val());
        selTextArr.push(thisOption.attr('data-value'));
    });
    if (totalPrice > 0) {
        pricetext = '+$' + (totalPrice / 100).toFixed(0)
    } else {
        pricetext = '';
    }
    var stepInputChecked = thisFieldset.find('input:checked').length;
    thisOptionStep.find('.multiSelectAction button').hide(); 
    if (stepInputChecked > 0) {
        thisOptionStep.find('.multiActionYes').show(); 
    } else {
        thisOptionStep.find('.multiActionNo').show(); 
    }


    clearTimeout(changeTimer2); 
    changeTimer2 = setTimeout(function(){ 
        thisFieldset.attr('data-price-text', pricetext);
        thisFieldset.attr('bundle-price', totalPrice);
        thisFieldset.attr('data-bundle', selArr.toString());
        thisFieldset.attr('data-value', selTextArr.toString());
        var bundlePrice = 0;
        console.log(activeSteps);

        //var mainProductPrice = parseInt($('.product-form__variants[name="id"] option:selected').attr('data-price'));
        var mainProductPrice = parseFloat($.trim($('.price__container .price-item--regular').text().replace('$', ''))) * 100;
        $.each(activeSteps, function(index, item) {
            var thisBundle = $('.optionStep[data-step="' + item + '"] .optionSelect.bundleSelect');
            var bundleItemPrice = parseInt(thisBundle.attr('bundle-price'));
            if (isNaN(parseInt(bundleItemPrice)) == false) {
              
                bundlePrice += bundleItemPrice;
                //console.log('bundleItemPrice', bundleItemPrice, bundlePrice);
            }
        });
        
        bundlePrice += parseInt(thisFieldset.attr('bundle-price'));
        var customTotalPrice = mainProductPrice + bundlePrice;
        //console.log(bundlePrice);
        
        let customTotalPriceHTML = '';
        if (prescriptionFlag && discountFlag) {
            customTotalPriceHTML = '<span class="sale">'+Shopify.formatMoney(customTotalPrice * discount100Decimal)+'</span> <s>'+Shopify.formatMoney(customTotalPrice)+'</s>';
        } else {
            customTotalPriceHTML = Shopify.formatMoney(customTotalPrice);
        }  
        //console.log('customizeTotal ccc', mainProductPrice, bundlePrice, customTotalPrice);
        alert('customizeTotal ccc');
        $('.customizeTotal').html(customTotalPriceHTML);


    }, 150);    
});
$('body').on('click', '.multiSelectAction .btn', function() {
    var thisOption = $(this).closest('.optionStep').find('.optionSelect input');
    var nextOpt = $(this).closest('.optionStep').next('.optionStep').attr('data-option');
    var dataAdvance = parseInt(thisOption.attr('data-advance'));    
    if (prescriptionFlag == false) {
        dataAdvance = dataAdvance + 1
    }
    //console.log(dataAdvance);
  activeSteps.push(currentStep);  
  changeStep(dataAdvance);   
});


var actionTimer;
var actionTimer2;
var actionTimer3;
$('body').on('change', '.product-form__input--swatch input', function() {
	clearTimeout(actionTimer);
	actionTimer = setTimeout(function() {
        console.log('product-form__input--swatch change');
		if (hasColorImage == true) {
			// has color alt
			var scrollPos = $(window).scrollTop(); 
			var selectedColor = $('.product-form__input--swatch input:checked').val()
			//console.log('change color', selectedColor, scrollPos, currentGalleryIndex);
			filterGallery(selectedColor, scrollPos, currentGalleryIndex);
		} else {
			// no color alt
		}	

	}, 300);	
      
});




// Play/pause toggle on click
$('.mainGallery').on('click', '[data-play-video]', function() {
  var $wrapper = $(this).closest('.videoWrapper');
  var video = $wrapper.find('video').get(0);

  if (video.paused) {
    video.play();
    $wrapper.addClass('playing');
    //$(this).fadeOut(200);
  } else {
    video.pause();
    $wrapper.removeClass('playing');
    //$(this).fadeIn(200);
  }
});


function filterGallery(filter, scrollPos, currentGalleryIndex) {
    console.log('filterGallery');
    //$('.productSlider').slick('slickUnfilter');
    // if filter is not present set the alt value

    var filter = slugify(filter);
    //console.log('filter: '+filter);
    if (filter == '') {
        filter = $('.gallerySlide').first().attr('data-alt');
    }
    var optImage;
    var singleOpts;
    var noAutoAdvVal = $('.optionSlider .optionStep[data-auto-adv="false"] input:radio:checked').attr('data-value');
    var noAutoAdvStep = $('.optionSlider .optionStep[data-auto-adv="false"]').attr('data-handle');

    clearTimeout(actionTimer2);
    actionTimer2 = setTimeout(function() {
    $('.optionModalImage .optionImage').each(function(idx) {
        //console.log('idx: '+idx);
        var galleryOpt = $(this).attr('data-option')+',';
        //console.log('galleryOpt: '+galleryOpt);
        var optImage = $('.gallerySlide[data-alt="'+filter+'"][data-option*="'+galleryOpt+'"] a').attr('href');

        var thisStep = $(this).attr('data-option');

        if (noAutoAdvVal != undefined) {
            //var lensOpt = $('.optionSlider .optionStep[data-option*="lens color"] input:radio:checked').attr('data-value');
            if ($(this).attr('data-option').indexOf(noAutoAdvStep) > -1) {
                //console.log('aaaaaaaaaa');
                optImage = $('.gallerySlide[data-alt="'+filter+'"][data-option*="'+galleryOpt+'"][data-lens="'+noAutoAdvVal+'"] a').attr('href');
            } else {
                //console.log('bbbbbbb');

                optImage = $('.gallerySlide[data-alt="'+filter+'"][data-option*="'+galleryOpt+'"][data-lens="'+noAutoAdvVal+'"] a').attr('href');  
                if (optImage === undefined) {
                  optImage = $('.gallerySlide[data-alt="'+filter+'"][data-option*="'+galleryOpt+'"] a').attr('href');     
                } 
                if (optImage === undefined) {
                    optImage = $('.gallerySlide[data-alt="'+filter+'"] a').first().attr('href'); 
                } 
            }
            
        } else {
            
            optImage = $('.gallerySlide[data-alt="'+filter+'"][data-option*="'+galleryOpt+'"] a').first().attr('href');
            if (optImage === undefined) {
                optImage = $('.gallerySlide[data-alt="'+filter+'"]').not('.slick-cloned').first().find('a').attr('href'); 
            } 
        }
        if (optImage != undefined) {
            optImage = optImage.replace('_1920x.', '_1600x.')
        }  
                       //console.log('optImage2:'+optImage);              
        $(this).find('.imageBox').html('<img src="'+optImage+'" loading="lazy" />');
        
    });
    $('.optionBody .optionImage').each(function(idx) {
        //console.log('idx: '+idx);
        var galleryOpt = $(this).attr('data-option')+',';
        galleryOpt = galleryOpt.replace('-bundle', '');
        console.log('galleryOpt: '+galleryOpt);
        var optImage = $('.gallerySlide[data-alt="'+filter+'"][data-option*="'+galleryOpt+'"] a').attr('href');

        var thisStep = $(this).attr('data-option');

        if (noAutoAdvVal != undefined) {
            //var lensOpt = $('.optionSlider .optionStep[data-option*="lens color"] input:radio:checked').attr('data-value');
            if ($(this).attr('data-option').indexOf(noAutoAdvStep) > -1) {
                //console.log('aaaaaaaaaa');
                optImage = $('.gallerySlide[data-alt="'+filter+'"][data-option*="'+galleryOpt+'"][data-lens="'+noAutoAdvVal+'"] a').attr('href');
            } else {
                //console.log('bbbbbbb');

                optImage = $('.gallerySlide[data-alt="'+filter+'"][data-option*="'+galleryOpt+'"][data-lens="'+noAutoAdvVal+'"] a').attr('href');  
                if (optImage === undefined) {
                  optImage = $('.gallerySlide[data-alt="'+filter+'"][data-option*="'+galleryOpt+'"] a').attr('href');     
                } 
                if (optImage === undefined) {
                    optImage = $('.gallerySlide[data-alt="'+filter+'"] a').first().attr('href'); 
                } 
            }
            
        } else {
            //console.log('cccc');

            optImage = $('.gallerySlide[data-alt="'+filter+'"][data-option*="'+galleryOpt+'"] a').first().attr('href');
            console.log('image:', filter, galleryOpt, optImage);
            if (optImage === undefined) {
                optImage = $('.gallerySlide[data-alt="'+filter+'"] a').first().attr('href'); 
            } 
        }
        if (optImage != undefined) {
            optImage = optImage.replace('_1920x.', '_720x.')
        }  
                       //console.log('optImage2:'+optImage);              
        $(this).find('.imageBox').html('<img loading="lazy" src="'+optImage+'" class="jsloaded" />');
        
    });
    }, 300);    
    /*
    var optImage;
    $('.optionBody .optionImage').each(function() {
        var galleryOpt = $(this).attr('data-option')+',';
        var optImage = $('.gallerySlide[data-alt="' + filter + '"][data-option*="' + galleryOpt + '"] a').attr('href');
        //undefined get the first image
        if (optImage === undefined) {
            optImage = $('.gallerySlide[data-alt="' + filter + '"] a').first().attr('href');
        }
        optImage = optImage.replace('_1920x1920.', '_640x640.')
        $(this).find('.imageBox').html('<img src="https://cdn.shopify.com/s/files/1/3102/1374/files/loading.gif?v=1622658523" data-src="' + optImage + '" class="lazyload" />');
    });
    */

    if ($.inArray(filter, altArray) != -1) {
        //console.log('filterGallery', filter);
		$('.mainGallery').slick('slickUnfilter');
		$('.mainGallery').slick('slickFilter', '[data-alt*="' + filter + '"]');

		$('.tmbNav').slick('slickUnfilter');
		$('.tmbNav').slick('slickFilter', '[data-alt*="' + filter + '"]');
		$('.tmbNav li:not(".slick-cloned")[data-alt*="'+filter+'"]').each(function(index) {
            $(this).attr('data-slick-index', index);
        });
		// add corerct index and go to slide 0
		$('.mainGallery').slick('slickGoTo', currentGalleryIndex);
		$('.tmbNav').slick('slickGoTo', currentGalleryIndex);


    } else {
        // nothing to filter add correct index and go to slide 0
        $('.tmbNav li:not(".slick-cloned")').each(function(index) {
            $(this).attr('data-slick-index', index);
        });
        $('.productSlider').slick('slickGoTo', 0);
    }
    $('.productGallery').removeClass('noTrack');
    if ($('.productGallery .tmbNav .slick-list').width() >= $('.productGallery .tmbNav .slick-track').width()) {
        $('.productGallery').addClass('noTrack');
    }

    // prevent auto scroll
    var scrollPosAfter =    $(window).scrollTop(); 
    var scrollDiff = scrollPosAfter - scrollPos;
    if (scrollDiff > 0 ) {
        $("html, body").animate({
         scrollTop: scrollPos
        }, 0);
    }        
} 
function showHideUnavailable() {    
    var variantJSON = JSON.parse($('#variantJSON').html());
    var selectedOpt1 = $('variant-selects [data-opt-pos="1"]:checked').val();
    var availableOptions = getAvailableOptions(variantJSON, selectedOpt1);

    //console.log(availableOptions.length);
    if (availableOptions.length > 0) {
      var opt2Avail = '';
      $('variant-selects label[data-opt-pos="2"]').addClass('hide');
      $.each(availableOptions, function(index, option) {
        $('variant-selects label[data-opt-pos="2"][data-value="'+option.option2+'"]').removeClass('hide');
        if (index == 0) {
          opt2Avail = option.option2;
        }
        if (option.available) {
          opt2Avail = option.option2;
        }
        //console.log("Option: " + option.option2 + " | Available: " + option.available);
      });
      var hiddenSelected = $('variant-selects [data-opt-pos="2"]:checked').next('label').hasClass('hide');
      
      if(hiddenSelected) {
        console.log('hiddenSelected', hiddenSelected, opt2Avail);
        $('variant-selects label[data-opt-pos="2"][data-value="'+opt2Avail+'"]').trigger('click');
      }
    }
 }   


function getAvailableOptions(variantArray, selectedOpt1) {
  return $.map(variantArray, function(variant) {
    if (variant.option1 === selectedOpt1) {
      return {
        option2: variant.option2,
        available: variant.available
      };
    }
  });
}

function updatePrice() {
    //alert('updatePrice');
    var mainTotalPrice = 0;
    var mainbundlePrice = 0;
    var mainProductPrice = parseInt($('.product-form__variants[name="id"] option:selected').attr('data-price'));
    var bundlePrice = 0;

    var customTotalPrice = mainProductPrice + bundlePrice;
    $('.customizeTotal').html(Shopify.formatMoney(customTotalPrice));
    $('.customizeForm #atcprice').val((customTotalPrice/100).toFixed(2));



    mainTotalPrice = mainProductPrice + mainbundlePrice;
    if ($('select.bundleSelect').length > 0) {
        $('select.bundleSelect').each(function() {
          var bundlePrice = parseInt($(this).find('option:selected').attr('data-price')); 
          mainTotalPrice += bundlePrice;
        });
    }
    if ($('.multiOption:checked').length > 0) {
        $('.multiOption:checked').each(function() {
          var optionPrice = parseInt($(this).attr('data-price')); 
          mainTotalPrice += optionPrice;
        });
    }

    $('.mainForm #origprice').val((mainProductPrice/100).toFixed(2));
    $('.mainForm #atcprice').val((mainTotalPrice/100).toFixed(2));

    $('.customizeForm #origprice').val((mainProductPrice/100).toFixed(2));
    $('.customizeForm #atcprice').val((mainTotalPrice/100).toFixed(2));

    $('.product__price .price-item--regular').text(Shopify.formatMoney(mainTotalPrice));

    var updateTimer;  
    if (typeof Afterpay != 'undefined') {
        afterpay_current_variant.price = mainTotalPrice;
        //$('afterpay-placement, square-placement').remove();
        clearTimeout(updateTimer);
        Afterpay.init($) 
        updateTimer = setTimeout(function(){ 
        $('.afterpay-box square-placement').first().nextAll('square-placement').remove()
        }, 300);
    }    

    

}


function referrerParam() {
    // var docRef = document.referrer;
    // var activityVal = '';
    // var sportVal = '';
    // if (document.referrer.indexOf('search?') > -1) {
    //     $('.mainForm #atcsrc').val('Search Page');
    //     $('.customizeForm #atcsrc').val('Search Page');
    // }
    // if (docRef.indexOf('?') > -1) {
    //   var docRefParm = getQueryParams(document.referrer.split('?')[1]);
    //   if (docRefParm.activity != undefined) {
    //      activityVal = docRefParm.activity.replace(/Activity_/g, '').replace(/,/g, '\|');
    //   } 
    //   if (docRefParm.sport != undefined) {
    //     sportVal = docRefParm.sport.replace(/Sport_/g, '').replace(/,/g, '\|');
    //   } 
        
    // }
    // $('.mainForm #atcactivity').val(activityVal); 
    // $('mainForm #atcsport').val(sportVal);

    // $('.customizeForm #atcactivity').val(activityVal);
    // $('.customizeForm #atcsport').val(sportVal);
}

function changeStep(step) {
    currentStep = currentStep + step;
    $('.optionModalBox').attr('data-current-step', currentStep);
    $('.optionStep[data-step="'+currentStep+'"] fieldset input').first().trigger('change');
    checklensButton(currentStep);
    updateOptionProgress(currentStep);
    console.log('changeStep');
}
function checklensButton(currentStep) {
    var stepTxt = $('.optionStep[data-step="'+currentStep+'"]').attr('data-option');
    // console.log(stepTxt);
    // console.log(stepInput);
    // console.log('currentStep:'+currentStep);
    // console.log('lensStep:'+lensStep);
    //console.log('currentStepVal:'+$('.optionStep[data-step="'+currentStep+'"]').attr('data-option'));
    if (stepTxt == lensStep && $('.optionStep[data-option="'+lensStep+'"] .noAdv input:checked').length > 0) {
    //if (stepTxt == lensStep) {
        //console.log('show add lens');    
        //console.log('show add lens');
        $('.chooseLens').show();
    } else {
        //console.log('hide add lens');
        $('.chooseLens').hide();
    }
    
}
function updateOptionProgress(currentStep) {
    var totalStep = $('.optionStep').length;
    var progressPercentage = (currentStep / totalStep) * 100;
    $('.optionModalWrapper .progressBar .progress ').width(progressPercentage+'%');
    if (progressPercentage == 100) {
        // last step
        setTimeout(function(){ 
            buildSummary();
        }, 1);
    }
    //console.log('currentStep:'+currentStep);

    // update step text
    var stepCount = activeSteps.length+1;
    if (progressPercentage >= 100) {
        $('.optionModalInfo .stepCount').text('Final Step');    
    } else {
        $('.optionModalInfo .stepCount').text('Step '+stepCount);  
    }
    // show hide next button
    if($('.optionStep[data-step="'+currentStep+'"] input:checked').length > 0) {
      $('.nextOption.optionActionBtn').show();
    } else {
      $('.nextOption.optionActionBtn').hide();
    }
    // update progress dots
    $('.progressMark dl dt').removeClass('active checked');
    $('.progressMark dl dt[data-step="'+currentStep+'"]').addClass('checked active');


    var duplicateStep = 'Coatings';
    var activeLabel = $('.progressMark dl dt[data-step="'+currentStep+'"]').attr('data-label'); 

    $('.progressMark dl dt').removeClass('hide');
    $('.progressMark dl dt[data-label="'+duplicateStep+'"]').next('[data-label="'+duplicateStep+'"]').addClass('hide');

    if (activeLabel == duplicateStep) {
      $('.progressMark dl dt[data-label="'+duplicateStep+'"]').addClass('active');
    }

    $.each(activeSteps, function(index, item) {
        $('.progressMark dl dt[data-step="'+item+'"]').addClass('checked');
    });
    setTimeout(function() {
        $.each(activeSteps, function(index, item) {
            var thisOption = $('.optionStep[data-step="' + item + '"] .optionSelect[data-option]');
            var customValue = thisOption.attr('data-value').trim().toLowerCase().replace(/\s+/g, '-');
            console.log(customValue);
            $('.customizeSection').attr('option-'+item, customValue);
        });  
    }, 100);
    
}
function buildSummary() {
    var prevStep = 'Step 1';
    $('#customTimestamp').val(Math.floor(Date.now() / 1000));
    $('.optionModalWrapper').attr('data-id', selectedVariantJSON.id);
    $('#customVariantID').val(selectedVariantJSON.id);

    $('.customProperties').html('');
    $('.selectedProperty').html('');

    var prodPriceText = parseFloat($.trim($('.price__container .price-item--regular').text().replace('$', '')));
    const prodPriceTextFormatted = (prodPriceText % 1 === 0) ? prodPriceText.toFixed(0) : prodPriceText.toFixed(2);


    $('.product__info-container variant-selects .product-form__input').each(function(index) {
        let xIndex = index + 1;
        var optionTitle = $(this).find('.form__label').text();
        var optionValue = $(this).find('input:checked').val();
        var prodType = $('.product__info-container variant-selects').attr('data-type');
        var isFrame = false; //;
        if (prodType == 'Frame' || prodType == '') {
            prodType = 'Frame';
            isFrame = true;
        } 
        //console.log('optionTitle:'+optionTitle);
        if (optionTitle.indexOf('Color') > -1) {
            optionTitle = prodType+' Color'
        } else if (optionTitle.indexOf('Size') > -1) {
            optionTitle = prodType+' Size' 
        }

        var prodPrice = '';
        if (xIndex == 1) {
            if (prescriptionFlag && discountFlag) {
                const prodPriceDecimal = prodPriceText;
                const prodPriceSale = prodPriceDecimal * discount100Decimal;
                const prodPriceSaleFormatted = (prodPriceSale % 1 === 0) ? prodPriceSale.toFixed(0) : prodPriceSale.toFixed(2);

                prodPrice = `<em><span class="sale">$${prodPriceSale.toFixed(2)}</span> <s>$${prodPriceTextFormatted}</s></em>`;
            } else {
                prodPrice = `<em>$${prodPriceText}</em>`;
            }  
        }

        $('.selectedProperty').append('<dt><strong>'+optionTitle+'</strong></dt><dd>'+optionValue+prodPrice+'</dd>');
        $('.customProperties').append('<input type="hidden" name="properties[_'+optionTitle+']" value="'+optionValue+'" />');
        

    });
    var noTYArr = $('.optionStep.reviewStep').attr('data-no-thanks').split('| ');
    var customizeAddons = [];
    $.each(activeSteps, function(index, item) {
        
        var thisOption = $('.optionStep[data-step="' + item + '"] .optionSelect[data-option]');
        var customKey = thisOption.attr('data-option').split(': ')[0];
        var bundlePrice = thisOption.attr('bundle-price');
        var customValue = thisOption.attr('data-value');

        var customPrice = thisOption.attr('data-price-text');

        if (customPrice.indexOf('+') > -1) {
            var match = customPrice.match(/(\+\$\d+(?:\.\d+)?)\s+(\$\d+(?:\.\d+)?)/);
            if (match) {
                var discount = match[1];
                var original = match[2];
                // Replace content with HTML
                customPrice = '<span class="sale">' + discount + '</span> <s>' + original + '</s>';
            }
        }

        

        if (jQuery.inArray(customValue, noTYArr) > -1) {
            customValue = '';
        }
        // if non prescription skip prescription option
        if (customKey.toLowerCase().indexOf('prescription option') > -1 && prescriptionFlag == false) {
            $('.optionStep  .uploadField').val('');
            customKey = '';
        }
        if (customKey.toLowerCase().indexOf('prescription option') > -1 && customValue.toLowerCase().indexOf('upload') > -1) {
            customValue = 'Attached Prescription: '+$('.uploadFieldBox .uploadField').val().split('\\').pop();
        }
        var xPrice = '<em>' + customPrice + '</em>';
        if (prevStep == customKey) {

            var xValue = $('.customProp[title="'+customKey+'"]').val()+', '+customValue;
            

            if ($('.selectedProperty dd[title="'+customKey+'"]').length == 0) {
                $('.customProperties').append('<input title="'+customKey+'" type="hidden" class="customProp" name="properties[' + customKey + ']" value="' + customValue + '" />');
                $('.selectedProperty').append('<dt class="aaa"><strong>' + customKey + '</strong></dt><dd title="'+customKey+'">' + customValue +xPrice+'</dd>');
            } else {
                $('.customProp[title="'+customKey+'"]').val(xValue);
                //$('.selectedProperty dd[title="'+customKey+'"]').html(xValue+xPrice); 
                $('.selectedProperty').append('<dd title="'+customKey+'">' + customValue +xPrice+'</dd>');
            }

            if (customKey != '' && customValue != '') {
                if (customKey != 'Prescription Option') {
                    if (customValue != 'Non-prescription') {
                        customizeAddons.push(customKey+' - '+customValue);
                    }
                }
            }    
        } else {
            if (customKey != '' && customValue != '') {

                let coatingPrice = xPrice;
                if (prescriptionFlag && discountFlag) {
                    if (customPrice != '' && customPrice != 'Free'  && customPrice.indexOf('sale') == -1) {
                       
                        const prodPriceDecimal = parseFloat(customPrice.replace(/[+$,]/g, ""));

                        const result = prodPriceDecimal * discount100Decimal;
                        const formatted = (result % 1 === 0) ? result.toFixed(0) : result.toFixed(2);

                        const prodPriceSale = `$${formatted}`;                        

                        coatingPrice = `<em><span class="sale">+${prodPriceSale}</span> <s>${customPrice.replace("+", "")}</s></em>`;
                    }
                    
                } 
                $('.customProperties').append('<input title="'+customKey+'" type="hidden" class="customProp" name="properties[' + customKey + ']" value="' + customValue + '" />');
                $('.selectedProperty').append('<dt class="bbb"><strong>' + customKey + '</strong></dt><dd title="'+customKey+'">' + customValue.replace(/,/g, ', ') +coatingPrice+ '</dd>');
                if (customKey != 'Prescription Option') {
                    if (customValue != 'Non-prescription') {
                        customizeAddons.push(customKey+' - '+customValue);
                    }
                }
                
            }
        }
        prevStep = customKey;
    });
    

    if (prescriptionFlag == false && nonPrescOpt != '') {
        
        var nonPrescOptArr = nonPrescOpt.split('; ');
        var xbundlePrice = 0;
        var mainProductPrice = selectedVariantJSON.price;
        $.each( nonPrescOptArr, function( key, value ) {
            var valueArr = value.split(':');
            var xKey = valueArr[0];
            var xValue = valueArr[1];

            var bundlePrice = parseInt($('.bundleStep[data-handle="'+xKey+'"] input[data-value-lowercase="'+xValue+'"]').attr('data-price'));
            var customKey = $('.bundleStep[data-handle="'+xKey+'"] .optionSelect').attr('data-option').split(': ')[0];
            var customPrice = $('.bundleStep[data-handle="'+xKey+'"] input[data-value-lowercase="'+xValue+'"]').closest('label').find('em').text();
            var customValue = $('.bundleStep[data-handle="'+xKey+'"] input[data-value-lowercase="'+xValue+'"]').attr('data-value');

            var xPrice = '<em>' + customPrice + '</em>';

            $('.customProperties').append('<input type="hidden" class="customProp" name="properties[' + customKey + ']" value="' + customValue + '" />');
            $('.selectedProperty').append('<dt class="ccc"><strong>' + customKey + '</strong></dt><dd>' + customValue +xPrice+ '</dd>');

            xbundlePrice += bundlePrice; 
        });
        // console.log('xbundlePrice:'+xbundlePrice);
        // console.log('mainProductPrice:'+mainProductPrice);
        alert('.customizeTotal aaa')
        $('.customizeTotal').html(Shopify.formatMoney(mainProductPrice+xbundlePrice));
        $('.customizeForm #atcprice').val((mainProductPrice+xbundlePrice/100).toFixed(2));
        $('.mainForm #atcprice').val((mainProductPrice+xbundlePrice/100).toFixed(2));
        
    } 
    
    if (customizeAddons.toString() == '') {
        $('.customizeForm #atcaddons').remove();
    } else {
        $('.customizeForm #atcaddons').remove();
        $('.customizeForm').prepend('<input type="hidden" id="atcaddons" name="properties[_AddOnList]" value="'+customizeAddons.toString().replace(/,/g, '\|')+'" />');
    }
    //console.log('_AddOnList', customizeAddons.toString().replace(/,/g, '\|'));
}
function updateCustomizeOptions() {
    $('select.single-option-selector').each(function() {
        var dataName = $(this).attr('data-name');
        // show hide option
        $('.optionSelect[data-option="' + dataName + '"] label').hide();
        $(this).find('option').each(function() {
            $('.optionSelect[data-option="' + dataName + '"] label[data-value="' + $(this).attr('value') + '"]').show();
        });
        // show hide option disclaimer
        var currentOptionCount = parseInt($('.optionSelect[data-option="' + dataName + '"]').attr('option-count'));
        var visibleOptionCount = $(this).find('option').length;
        var currentDisclaimer = $('.optionSelect[data-option="' + dataName + '"]').closest('.optionStep').find('.optionDisclaimer')
        if (currentOptionCount > visibleOptionCount) {
            currentDisclaimer.show();
        } else {
            currentDisclaimer.hide();
        }
    });    
}



function addtoCartAddons() {
    $.ajaxSetup({
        async: false,
    });
    var addOnArray = [];
    var addOnTitleArr = [];
    var customProp = {};

    // if has add on bundle
    $('.addOnProperties').html('');
    if ($('.bundleSelect').length > 0 || $('.multiOption:checked').length > 0 ) {
        var selectedVariantID = $('.product-form__variants[name="id"]').val();

        var bundleTS = Math.floor(Date.now() / 1000);
        var addOnProperty = {};
        addOnProperty['_Timestamp'] = bundleTS;
        addOnProperty['_Product Title'] = $('.mainForm').data('product-title');
        addOnProperty['_Product ID'] = $('.mainForm').data('product-id');
        addOnProperty['_Product ID'] = $('.mainForm').data('product-id');
        addOnProperty['_HR'] = '-----';



        $('.addOnProperties').append('<input type="hidden" name="properties[_Timestamp]" value="'+bundleTS+'" />');
        $('.multiOption:checked').each(function(index) {
            var indexNo = index + 1;
            var itemProp = $(this).attr('name')+' #'+indexNo;
            //parentProperty[itemProp] = $(this).data('title');
            $('.addOnProperties').append('<input type="hidden" name="properties['+itemProp+']" value="'+$(this).data('title')+'" />');
            addOnArray.push($(this).val());
            addOnTitleArr.push($(this).data('title').split(' [')[0]);
            // push customProp 
            customProp[itemProp] = $(this).data('title').split(' [')[0];
        });
       
        $('.bundleSelect').each(function(index) {
            var selectlabel = $(this).closest('.selector-wrapper').data('label');
            var selectedOption = $(this).find('option:selected');
            if (selectlabel != undefined && selectedOption != undefined) {
                $('.addOnProperties').append('<input class="bundleSelectVal" type="hidden" name="properties['+selectlabel+']" value="'+selectedOption.data('title')+'" />');
                if (selectedOption.data('price') > 0) {
                    //parentProperty[selectlabel] = selectedOption.data('title');
                    addOnArray.push($(this).val());
                    addOnTitleArr.push($(this).val());
                }
            }
            customProp[selectlabel] = selectedOption.data('title');
        }); 
        $('.addOnProperties').append('<input type="hidden" name="properties[_AddOnList]" value="'+addOnTitleArr.toString().replace(/,/g, '\|')+'" />');
        $('.addOnProperties').append('<input type="hidden"  name="properties[_HR]" value="-----" />');


        // klaviyo 
        pushItem($('.mainForm'), '', 'Added to Cart', customProp);
        
        //has add on selected
        if (addOnArray.length > 0) {
            var addOnCount = addOnArray.length;
            
            $.each(addOnArray, function(key, value) {
                var addOnParams = {
                    quantity: 1,
                    id: value
                };
                addOnParams.properties = addOnProperty;
                $.ajax({
                    type: 'POST',
                    url: '/cart/add.js',
                    dataType: 'json',
                    async: false,
                    data: addOnParams,
                    success: function() {
                        //alert('ajax success add');
                    },
                    error: function() {}
                });
            });
            
            //console.log('loop finish submit main form');
            //alert('submit form');
            setTimeout(function() {
                $('.mainForm').submit();
            }, 600);
            
        } else {
            //console.log('submit without add on')
            pushItem($('.mainForm'), '', 'Added to Cart', customProp);
            setTimeout(function() {
                $('.mainForm').submit();
            }, 600);
        }
        
    } else {
        // normal submit
        //console.log('normal add', addOnProperty);
        pushItem($('.mainForm'), '', 'Added to Cart', customProp);
        setTimeout(function() {
            $('.mainForm').submit();
        }, 600);
    }
    $.ajaxSetup({
        async: true, 
    });
}

function pushItem(form, addOnArray, event, properties) {
    //console.log('pushItem', 'event:'+event, addOnArray, properties);
    
    var form = form;
    var category = window.location.pathname === '/search' ? $item.data('cat').split(' - ')[0] : $('.collectionBox ').attr('data-name');
    var $item = form.closest('.product-single');
    var bundleArr = '';
    var bundleAttr = '';
    if (properties === undefined) {
        properties = [];
    }

    if (addOnArray != '') {
        var bundleTitle = 'Addons';
        var bundleArr = ''
        var bundleAttr = '';

        $.each(addOnArray, function( key, value ) {
            if (key == 0) {
                bundleArr += value;
            } else {
                bundleArr += ';'+value;
            }
        });

        if(window.location.href.indexOf('?') > -1) {
            bundleAttr = '&'+bundleTitle+'='+bundleArr;
        } else {
            bundleAttr = bundleTitle+'='+bundleArr;
        }
    }
    var addOnPropValJson = {};
    if ($('.customizeForm #atcaddons').length > 0) {
        var addOnPropVal = $('.customizeForm #atcaddons').val();
        var addOnPropValArr = addOnPropVal.split('|');
        

        addOnPropValArr.forEach(function(item) {
            var parts = item.split(' - ');
            var key = parts[0].trim();
            var value = parts[1]?.trim() || "";
            addOnPropValJson[key] = value;
        });
    } 
    
    var cItem = {
        Name: $('.optionModalWrapper').attr('data-title'),
        ProductID: $('.customizeForm').attr('data-productid'),
        Categories: ['Rec Specs'],
        Proprties: addOnPropValJson,
        ImageURL: 'https:'+$('.customizeForm .atcimage').val(),
        URL: $('.customizeForm .atcurl').val(),
        Brand: 'Rec Specs',
        Price: $('.customizeForm #origprice').val()
    }
    console.log('cccc',event, cItem);
         

    if (typeof window._learnq !== 'undefined') {
        console.log("Klaviyo is defined.");
        if (customerEmail) {
              _learnq.push(['identify', {
              "$email": customerEmail
            }]);
        } 
        if (_learnq != undefined) {
            _learnq = _learnq || [];

            if (event == 'Added to Cart') {
                _learnq.push(['track', 'Added to Cart', cItem]);
            }
            if (event == 'Viewed Product') {
                _learnq.push(['track', 'Viewed Product', cItem]);
            }
        }
    }
}


function filterSwatches() {
    var firstAvailOpt1 = $('.single-option-selector[data-index="option1"]').val();
    var firstAvailOpt2 = $('.single-option-selector[data-index="option2"]').val();

    if (firstAvailOpt1 != undefined && firstAvailOpt2 != undefined) {
        $('.swatch[data-option-index="0"]  .swatch-element').addClass('unavailable');
        $('.main-product-variants option[data-option2="' + firstAvailOpt2 + '"]').each(function() {
            $('.swatch[data-option-index="0"] .swatch-element[data-value="' + $(this).attr('data-option1') + '"]').removeClass('unavailable');
        });

        $('.swatch[data-option-index="1"] .swatch-element').addClass('unavailable');
        $('.main-product-variants option[data-option1="' + firstAvailOpt1 + '"]').each(function() {
            $('.swatch[data-option-index="1"] .swatch-element[data-value="' + $(this).attr('data-option2') + '"]').removeClass('unavailable');
        });

        var selectedNone1 = $('.swatch[data-option-index="1"] .swatch-element.unavailable input:checked').length;
        if (selectedNone1 > 0) {
            $('.swatch[data-option-index="1"] .swatch-element').not('.unavailable').first().find('input').prop('checked', true);
        }
    }
}

var reqCount = 0;

Shopify.moveAlong = function() {

    if (Shopify.queue.length) {
        var request = Shopify.queue.shift();
        Shopify.addItem(request.variantId, request.quantity, request.properties, Shopify.moveAlong);
    } else {
        //document.location.href = '/cart';
    }
};
Shopify.addItem = function(id, qty, properties, callback) {
    var params = {
        quantity: qty,
        id: id
    };
    if (properties != false) {
        params.properties = properties;
    }
    $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        dataType: 'json',
        data: params,
        success: function() {
            if (typeof callback === 'function') {
                callback();
            }
        },
        error: function() {
            alert('error');
        }
    });
}

function push_to_queue(variantID, quantity, properties, callback) {
    Shopify.queue.push({
        variantId: variantID,
        quantity: quantity,
        properties: properties
    });
    if (typeof callback === 'function') {
        callback();
    }
}


function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

function showHideOpts() {
    var showHideOptionVal = $('.optionModalWrapper').attr('data-show-option');
    var showHideOptionValArr = showHideOptionVal.split('; ');

    $('.optionStep .optionSelect label').closest('label').show();
    $.each(showHideOptionValArr, function(index, value) {
        var valueArr = value.split(' = ');
        var valueKey = valueArr[0].split(':: ');
        var valueVal = valueArr[1];


        var selectedOpt = $('.optionStep[data-option="' + valueKey[0] + '"] .optionSelect input[data-value-lowercase="' + valueKey[1] + '"]:checked').length;
        if (selectedOpt > 0) {
          var stepKey = valueArr[1].split(':: ')[0];
          var stepValArr = valueArr[1].split(':: ')[1].split('| ');

          console.log('stepKey:'+stepKey);

          $('.optionStep[data-option="' + stepKey + '"] .optionSelect label').closest('label').hide();
          $.each(stepValArr, function(k, v) {
              $('.optionStep[data-option="' + stepKey + '"] .optionSelect input[data-value-lowercase="' + v + '"]').closest('label').show();
          });

        }
    });
}


function showHideBundleOpt() {  
    //console.log('showHideBundleOpt');
    var showHideOpts = $('.product-form__controls-group').attr('data-show-option');
    if (showHideOpts != undefined) {
        if (showHideOpts != '') {
            var showHideOptsArr = showHideOpts.split('; ');
            $.each(showHideOptsArr, function(key, value) {
                //console.log(value);
                var optLabel = value.split(':: ')[0];
                var optValue = value.split(' = ')[0].split(':: ')[1];
                var selectedOption = $('.bundleSelect[data-label="' + optLabel + '"] option:selected').attr('data-title');
                if (optValue == selectedOption) {
                    var optHidelabel = value.split(' = ')[1].split(':: ')[0];
                    var optHideValueArr = value.split(' = ')[1].split(':: ')[1].split('| ');


                    $('.bundleSelect[data-label="' + optHidelabel + '"] option').each(function() {
                        var optTitle = $(this).attr('data-title');
                        var titleInArr = $.inArray(optTitle, optHideValueArr)
                        $(this).removeAttr('disabled');

                        if (titleInArr == -1) {
                            $(this).attr('disabled', 'disabled');
                            $(this).prop("selected", false)
                        }
                        //$(this).closest('select').find('option').not('[disabled]').first().prop("selected", true);
                    });

                }
            });
        }
    }
}

function loadCustomizer() {
    var prodHandle = $('.customizeSection').attr('data-handle');
    $('body').addClass('ajaxLoading');
    $('.customizeSection').load(window.location.pathname+'?view=customizer', function() {
        applyDiscountPrice();
        referrerParam()  
        nonPrescOpt = $('.optionModalWrapper').attr('data-non-prescription-opts');
        var filter = $('.product-form__input--swatch input:checked').val();
        $('.optionStep  .uploadField').val('');
        if (filter == undefined) {
            filter = '';    
        }
        filter = filter.replace(/\W+(?!$)/g, '-').toLowerCase();
        filter = filter.replace(/\W$/, '').toLowerCase();
        
        var scrollPos =    $(window).scrollTop(); 

        //console.log(filter);
        //console.log(scrollPos);
        //console.log(currentGalleryIndex);
        filterGallery(filter, scrollPos, currentGalleryIndex);


        $('body').removeClass('ajaxLoading');

        var optsActionHTML  = '<span class="actionBox"><button type="button" class="chooseMe">Choose this lens</button><button type="button" class="cancel">Cancel</button></span>';
        $('.optionStep[data-auto-adv="false"] .optionSelect label').each(function() {
            
            var optInput = $(this).find('input[type="radio"]');
            var optTitle = $(this).closest('.optionStep').attr('data-handle');
            var inArr = $.inArray(optTitle, advOptsArr); 

            if (inArr > -1) {
                lensStep = $(this).closest('.optionStep').attr('data-option');
                $(this).addClass('noAdv');
                optInput.attr('data-advance', 0);
                $(this).find('.actionBox').remove();
                $(this).append(optsActionHTML);
            }
        });
        // set skip steps option
        var nextOptionVal = $('.optionModalWrapper').attr('data-next-steps');
        //console.log(nextOptionVal);
        if (nextOptionVal != '') {
            var nextOptionValArr = nextOptionVal.split('; ');
            $.each(nextOptionValArr, function(index, value) {
                var valueArr = value.split(' = ');
                var valueKey = valueArr[0].split(': ');
                var valueVal = valueArr[1];
                $('.optionStep[data-option="' + valueKey[0] + '"] .optionSelect input[data-value-lowercase="' + valueKey[1] + '"]').attr('data-next-step', valueVal);
            });
        }

        $('.optionSlider .optionStep .heading h3').each(function() {
            $(this).closest('.optionStep').find('.optionImage').after('<h3 class="optionHead">'+$(this).text()+'</h3>')
        });

        // set show hide option
        if ($('.optionModalWrapper').length > 0) {
            var showHideOptionVal = $('.optionModalWrapper').attr('data-show-option');
            if (showHideOptionVal != '') {
                var showHideOptionValArr = showHideOptionVal.split('; ');
                $.each(showHideOptionValArr, function(index, value) {
                    var valueArr = value.split(' = ');
                    var valueKey = valueArr[0].split(': ');
                    var valueVal = valueArr[1];
                    $('.optionStep[data-option="' + valueKey[0] + '"] .optionSelect input[data-value-lowercase="' + valueKey[1] + '"]').attr('data-next-option', valueVal);
                });
            }
        }
        setTimeout(function() {
          var varImg = $('.main-product-variants option:selected').attr('data-image');
          $('.atcurl').val(window.location.href);    
          $('.atcimage').val(selectedVariantJSON.featured_image.src.replace('.jpg', '_300x.jpg').replace('.png', '_300x.png'));    
        }, 100);
        showHideOpts();
    });
}
function buildGalleryImages(data, img, alt) {
    var html = ''
    var sizeArr = ['481:657', '361:448', '328'];
    var sizeArrSize = sizeArr.length - 1;
    var xSizes = '';
    var xSrcsets = '';
    $.each(sizeArr, function(key, value) {
        var imgSizeArr = value.split(':');
        if (key != sizeArrSize) {
            xSizes += '(min-width: ' + imgSizeArr[0] + 'px) ' + imgSizeArr[1] + 'px, ';

            var imgXsrc = data.replace('.jpg', '_' + imgSizeArr[1] + 'x.jpg').replace('.png', '_' + imgSizeArr[1] + 'x.png').replace('.webp', '_' + imgSizeArr[1] + 'x.webp') + ' ' + imgSizeArr[1] + 'w, ';
            xSrcsets += imgXsrc;
        } else {
            xSizes += imgSizeArr[0] + 'px';
            var imgXsrc = data.replace('.jpg', '_' + imgSizeArr[0] + 'x.jpg').replace('.png', '_' + imgSizeArr[0] + 'x.png').replace('.webp', '_' + imgSizeArr[0] + 'x.webp') + ' ' + imgSizeArr[0] + 'w';
            xSrcsets += imgXsrc;
        }
    });
    $(img).attr('sizes', xSizes).attr('srcset', xSrcsets).attr('alt', alt);
}


function applyDiscountPrice() {
    discountFlag = false;
    const allProductTag = $('[data-pdp-tag]').attr('data-pdp-tag').split(', ');

    if (theme.custom.autoDiscount && allProductTag.includes(theme.custom.autoDiscountTag)) {
        discountFlag = true;
        appliedDiscount = theme.custom.autoDiscountPercentage;
        discount100Decimal = 1 - (appliedDiscount / 100);
    }

    if (theme.custom.appliedDiscountCode == theme.custom.customDiscountCode) {
        appliedDiscount = theme.custom.customDiscountPercentage;
        discount100Decimal = 1 - (appliedDiscount / 100);
        discountFlag = true;
    }
    

    if (discountFlag) {
      $('[data-price-discount-no-zero]').each(function() {
        var priceText = $(this).attr('data-price-discount-no-zero');
        var priceVal = parseFloat(priceText.replace(/[^0-9.]/g, ''));

        var priceDiscount = priceVal * discount100Decimal;
        const priceDiscountFormatted = (priceDiscount % 1 === 0) ? priceDiscount.toFixed(0) : priceDiscount.toFixed(2);
        const priceValFormatted = (priceVal % 1 === 0) ? priceVal.toFixed(0) : priceVal.toFixed(2);



        $(this).addClass('sale').find('s').html('$'+priceValFormatted);
        $(this).find('span').html('$'+priceDiscountFormatted);
      });
    } else {
      $('[data-price-discount-no-zero]').each(function() {
        var priceText = $(this).attr('data-price-discount-no-zero');
        $(this).removeClass('sale').find('s').html('');
        $(this).find('span').html(priceText);
      });  
    }
}
$(function() {
    var $actionBox = $('.pdpActionBox');
    var $stickyAtc = $('[data-sticky-atc]');

    var $actionBox = $('.pdpActionBox');
    var $stickyAtc = $('[data-sticky-atc]');

    if (!$actionBox.length || !$stickyAtc.length) return;

    $(window).on('scroll resize', function() {
        var scrollTop = $(window).scrollTop();
        var windowHeight = $(window).height();

        var elementTop = $actionBox.offset().top;
        var elementBottom = elementTop + $actionBox.outerHeight();

        var isPast = scrollTop > elementBottom;
        var isVisible =
            elementBottom > scrollTop &&
            elementTop < scrollTop + windowHeight;

        if (isPast && !isVisible) {
            $stickyAtc.addClass('is-visible');
        } else {
            $stickyAtc.removeClass('is-visible');
        }
    }).trigger('scroll');

    $('[data-sticky-atc-add]').on('click', function(e) {
        e.preventDefault(); // prevent default link behavior if it's a link

        var $target = $('variant-selects');
        if ($target.length) {
            var headerHeight = $('.header-group').outerHeight() || 0; // get header height
            var scrollPosition = $target.offset().top - headerHeight;
            var isAvail = true;
            if ($(this).hasClass('is-disabled')) {
                isAvail = false;
            }

            $('html, body').animate(
              {
                scrollTop: scrollPosition
              },
              300,
              function () {
                if (isAvail) {
                    $('.customizeBtn').trigger('click')
                }
              }
            );
        }
    });
    $('[data-variant-change]').on('click', function(e) {
        e.preventDefault(); // prevent default link behavior if it's a link

        var $target = $('variant-selects');
        if ($target.length) {
            var headerHeight = $('.header-group').outerHeight() || 0; // get header height
            var scrollPosition = $target.offset().top - headerHeight;
            var isAvail = true;
            if ($(this).hasClass('is-disabled')) {
                isAvail = false;
            }

            $('html, body').animate(
              {
                scrollTop: scrollPosition
              },
              300,
              function () {

              }
            );
        }
    });
});



function isInViewport(el, offset = 75) {
  const rect = el.getBoundingClientRect();
  return (
    rect.top < window.innerHeight - offset &&
    rect.bottom > offset
  );
}

function updateStickyATC() {
  const variantSelects = document.querySelector('variant-selects');
  const pdpActionBox = document.querySelector('.pdpActionBox');
  const target = document.querySelector('[data-sticky-atc]');

  if (!target) return;

  const isVisible =
    (variantSelects && isInViewport(variantSelects, 75)) ||
    (pdpActionBox && isInViewport(pdpActionBox, 75));

  target.setAttribute('data-sticky-atc', isVisible ? 'false' : 'true');
}

window.addEventListener('load', updateStickyATC);
window.addEventListener('scroll', updateStickyATC);
window.addEventListener('resize', updateStickyATC);
